import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, remove, scrollInfo } from 'kapix-components-vue3'
import expertRessourcesOrganiserSaFormationStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'expertRessourcesOrganiserSaFormation'
const customImplement: CustomStoreImplementationOptions = expertRessourcesOrganiserSaFormationStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function expertRessourcesOrganiserSaFormationFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-3-organiser-sa-formatio.title', 'Organiser sa formation '),
        $description: $translate('expert-ressource-3-organiser-sa-formatio.description', 'Vous allez animer votre première formation et vous ne savez pas comment répartir l\'accompagnement dans le temps ? Matchers vous accompagne pour construire votre formation sur plusieurs séances !'),
        $publishedTime: new Date('2023-08-01T13:10:04.774Z'),
        $modifiedTime: new Date('2023-09-14T09:02:32.859Z'),
        // Constants,
        $constants: {
          dropDownRessourceContentText: '<p><strong>Les sessions de formation</strong> vont être espacées dans le temps et le plus souvent à distance. Il est important d’arriver à <strong>créer un lien humain </strong>avant de se lancer dans un rapport purement professionnel. Lors de la première session de formation, faire un tour de table vous permettra de mieux comprendre le rôle et les compétences de chacun.&nbsp;</p><p>&nbsp;</p><p><span style="color:#929292FF;"><i>“Nous allons chacun nous présenter. Je vous laisse dire quelques mots sur votre rôle au sein de l\'équipe. Je serais également ravi de connaître vos passions, cela permettra d’en apprendre un peu plus sur chacun d’entre nous”.&nbsp;</i></span></p><p>&nbsp;</p><p>Au cours du tour de table, il ne faut pas oublier de VOUS présenter ! Reprenez quelques éléments de votre <strong>parcours professionnel</strong> pour asseoir votre légitimité. Vous pouvez également exposer <strong>vos motivations personnelles à intervenir comme formateur</strong>.</p><p>&nbsp;</p>',
          element2ContentText: '<p>Comment voyez-vous la formation et les échanges durant les sessions ? Quelle est votre manière de travailler ? Pour présenter la méthodologie des formations Matchers vous pouvez vous appuyer sur <a href="/pedagogie"><span style="color:#D93174FF;">notre pédagogie</span></a> et la ressource <span style="color:#D93174FF;">&gt; Comment animer une formation Matchers ?</span></p><p>&nbsp;</p><p>Pour l’équipe Matchers, <strong>le but d’une formation </strong>est avant tout qu’elle soit utile ! Le message à faire passer dès le début : <strong>ce n\'est pas une formation dans laquelle les apprenants sont passifs</strong>. Au contraire, les apprenants nourrissent la formation avec, leurs questions, leurs besoins, leurs problématiques quotidiennes et surtout, le travail qui vont fournir entre chaque session. &nbsp;</p><p>&nbsp;</p>',
          element3ContentText: '<p>Pour cette première session, vous avez commencé à construire plusieurs slides sur le<span style="color:#D93174FF;"> support de formation</span>. Nous vous recommandons de commencer par un sommaire de la séance avec, par exemple, 20 min d’explications théoriques et par la suite, 1h30 de mise en pratique.&nbsp;</p><p>&nbsp;</p>',
          element4ContentText: '<p>En tant que <strong>formateur</strong>, vous pouvez adopter deux positions : <strong>la position basse</strong> ou <strong>la position haute</strong>. La position haute place <strong>le formateur comme un expert </strong>dans son domaine qui transmet ses connaissances. En position basse, l’expert se place comme celui qui “ne sait pas”. Il questionne et reformule pour faire émerger toutes les problématiques que peut rencontrer l’équipe. Cette position se concentre beaucoup moins sur l’expertise et permet au formateur de bien cerner les besoins.</p><p>&nbsp;</p><p>Pour partir dans la bonne direction, il est essentiel de bien comprendre l’environnement de travail de l’entreprise et le rôle de chacun. Selon<strong> la thématique de la formation </strong>et les sujets qu’elle traite vous pouvez tout à fait commencer par l’état des lieux de l’existant. En tant que <strong>formateur</strong>, à chaque étape vous devez former les apprenants sur “comment optimiser leurs tâches ou comment éviter un problème…”. Tous les échanges oraux ou manipulations spécifiques qui amène une réponse à leur besoin sont intéressants à transposer sur le <span style="color:#D93174FF;">support de formation.</span></p><p>&nbsp;</p>',
          element6ContentText: '<p>En quelques slides vous avez présenté les bonnes pratiques et les questions à se poser. Place à la pratique.&nbsp;</p><p>&nbsp;</p><p><span style="color:#616161;"><i>Exemple : Mettre en place une stratégie digitale sur les RS.</i></span></p><p>&nbsp;</p><p>Vous pouvez proposer aux apprenants d’<strong>analyser les points forts et points faibles</strong> de leur stratégie actuelle et d’identifier des axes d’amélioration. En restant sur le format d’échange vous pouvez rebondir sur les points qu’ils mettent en avant et ceux qu’ils auraient oubliés.</p><p>&nbsp;</p>'
        },
        // Data,
        $info: { expertRessource3OrganiserSaFormatio: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async toutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text4Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text5Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text6Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text7Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text8Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async text9Click () {
        await navigateTo({ hash: '#text-3--p97' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async previewRessourceShortClick () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element8Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element9Click () {
        await navigateTo({ name: 'Expert-Ressources-Evaluations' })
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return expertRessourcesOrganiserSaFormationFactory(storeId)()
}

export const expertRessourcesOrganiserSaFormationRaw = expertRessourcesOrganiserSaFormationFactory()
export const expertRessourcesOrganiserSaFormation = () => expertRessourcesOrganiserSaFormationRaw() as MergeCustomStore<typeof expertRessourcesOrganiserSaFormationStoreCustom.instance>
